// Register.js
import React, {useEffect, useRef, useState} from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import {Box, Button, Typography} from "@mui/material";
import {ProvidersService} from "../services/ProvidersService";
import {useKeycloak} from "@react-keycloak/web";
import LoadingSpinner from "../components/LoadingSpinner";
import {Helmet} from "react-helmet";


const Register = () => {
    const location = useLocation();
    const parsed = queryString.parse(location.search);
    const { keycloak, initialized} = useKeycloak();
    let subscriberId = keycloak.tokenParsed.sub;
    const timerRef = useRef(null);
    const [responseMessage, setResponseMessage] = useState(<span />);
    const [statusCode, setStatusCode] = useState(0);
    const [reload, setReload] = useState(0);

    const invitation = parsed.invitation || "";
    const isInvitationFlow = !!invitation;

    useEffect(()=> {
        setStatusCode(0);
        if(initialized && keycloak.token){
            timerRef.current = setTimeout(() => {
                if (isInvitationFlow) {
                    // Invitation flow: claim the existing crawled provider record
                    ProvidersService.claimProvider(invitation).then((response) => {
                        if(!response) setStatusCode(600);
                        else setStatusCode(response.status);
                    });
                } else {
                    // Self-registration flow: create a new provider keyed by Keycloak sub
                    let provider = {
                        id: subscriberId,
                        name: parsed.name,
                        address: parsed.address,
                        city: parsed.city,
                        state: parsed.state,
                        postalCode: parsed.postalCode,
                        email: parsed.email,
                        phoneNumber: parsed.phoneNumber,
                        categoryType: parsed.category,
                    };
                    console.log(provider);
                    ProvidersService.updateProvider(provider).then((response) => {
                        if(!response) setStatusCode(600);
                        else setStatusCode(response.status);
                    });
                }
            }, 5000);

            return () => clearTimeout(timerRef.current);
        }
    }, [subscriberId, initialized, reload, keycloak.token, parsed.name, parsed.address, parsed.city, parsed.state, parsed.postalCode, parsed.email, parsed.phoneNumber, parsed.category, invitation]);

    useEffect(() => {
        if (statusCode === 0) {
            setResponseMessage(<span>{isInvitationFlow ? "Claiming your business profile\u2026" : "Please wait while we register your account"}</span>);
        }
        else if (statusCode === 200) {
            setResponseMessage(
                <span>
                    <span>Congratulations! Your business is now registered!</span>
                    <br/>
                    <br/>
                    <span>Let's get your business profile setup.</span>
                </span>);
            console.log("Status Code: " + statusCode);
        } else if (statusCode === 409) {
            setResponseMessage(<span>This business has already been claimed by another account. If you believe this is an error, contact us at <a href="mailto:help@paircare.ai">help@paircare.ai</a>.</span>);
            console.log("Status Code: " + statusCode);
        } else if (statusCode === 410) {
            setResponseMessage(<span>Your invitation link has expired. Please contact us at <a href="mailto:help@paircare.ai">help@paircare.ai</a> to request a new one.</span>);
            console.log("Status Code: " + statusCode);
        } else if (statusCode === 400) {
            setResponseMessage(<span>Oops, looks like something went wrong... Please contact us at <a href="mailto:help@paircare.ai">help@paircare.ai</a> and one of our representatives will be happy to assist you.</span>);
            console.log("Status Code: " + statusCode);
        } else if (statusCode === 401) {
            setResponseMessage(<span>Uh-oh, looks like you are not signed in. Go back to the home page and log in again. If the error persists, contact us at <a href="mailto:help@paircare.ai">help@paircare.ai</a></span>);
            console.log("Status Code: " + statusCode);
        } else if (statusCode === 403) {
            setResponseMessage(<span>Uh-oh, looks like you don't have permission. Contact us at <a href="mailto:help@paircare.ai">help@paircare.ai</a> and one of our representatives will be happy to assist you.</span>);
            console.log("Status Code: " + statusCode);
        } else {
            setResponseMessage(<span>Oops looks like something went wrong... please try again. If the issue continues, please contact us at <a href="mailto:help@paircare.ai">help@paircare.ai</a> and one of our representatives will be happy to assist you.</span>);
            console.log("Status Code: " + statusCode);
        }
    }, [statusCode]);

    return (
            <Box margin={"20px"} width={"calc(100vw - 40px)"} minHeight={"calc(100dvh - 220px)"} display="grid" style={{alignContent:"center"}}>
                <Helmet>
                    <title>PairCare - Registering your business</title>
                </Helmet>
                {statusCode === 0 && <LoadingSpinner statusMessage={responseMessage} />}
                {statusCode !== 0 && <Typography style={{margin: "auto", marginTop:"20px", textAlign:"center", maxWidth:"500px"}} variant={"overline"}>{responseMessage}</Typography>}
                {statusCode === 200 && <Button style={{margin: "auto", marginTop:"20px", width: "100%", maxWidth:"500px"}} variant={"contained"} onClick={() => {window.location.replace("/registration")}}>Next</Button>}
                {statusCode === 500 && <Button style={{margin: "auto", marginTop:"20px", width: "100%", maxWidth:"500px"}} variant={"contained"} onClick={() => {setReload(reload+1)}}>Try Again</Button>}
            </Box>
    );
};

export default Register;
